import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"social-match-candidate",
	() => import("../ui/social-match-candidate-popup"),
)
registerLazyNotificationRenderer(
	"social-match-found",
	() => import("../ui/social-match-found-popup"),
)
registerLazyNotificationRenderer(
	"social-match-pending",
	() => import("../ui/social-match-pending-popup"),
)
registerLazyNotificationRenderer(
	"social-match-expired",
	() => import("../ui/social-match-expired-popup"),
)
registerLazyNotificationRenderer(
	"social-match-not-found",
	() => import("../ui/social-match-not-found-popup"),
)
registerLazyNotificationRenderer(
	"social-match-rejected",
	() => import("../ui/social-match-rejected-popup"),
)
